import React from 'react';
import { InputField } from '../controls/Fields/InputField';
import { StatusBar } from '../controls/StatusBar';
import { ArcaComponent } from './ArcaComponent';

export class Forgotten extends ArcaComponent {

    constructor(props) {
        super(props);
        this.state = {
            email: null,
            formValid : false
        };
    }

    render() {
        return (
            <div>
                <h1 id="tabelLabel">Forgotten Account</h1>
                <p>Please enter your email and if we find your account, we send a link to reset your account.</p>

                <InputField
                    fieldname='Email Address'
                    regularExpression='email'
                    warnText='Invalid email format'
                    mandatory={true}
                    value={this.state.email}
                    onUpdate={this.emailCallback.bind(this)}
                    fieldValid={this.state.emailValid}
                    fieldClass='simpleInputField' />
          
       
                <button type="button" className="btn btn-primary" onClick={this.onSubmit.bind(this)} disabled={!this.state.formValid}>Request password</button>
                <StatusBar isError={this.state.isError} message={this.state.statusText} />
            </div >
        );
    }

    emailCallback(email, isValid) {
        this.setState({
            email: email,
            formValid: isValid
        });
    }

    async onSubmit() {
        try {
            const response = await fetch('person/Forgotten', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email: this.state.email,
                })
            });

            /* eslint-disable default-case */
            switch (response.status) {
                case 200: {
                    const msg = await response.json();
                    this.setState({
                        formValid: false,
                        statusText: msg,
                    });

                    break;
                }

                case 400: {
                    const message = await response.json();

                    this.setState({
                        formValid: false,
                        statusText: message,
                    });
                    break;
                }
            }
            /*eslint-enable */
        }
        catch (error) {
            this.setState({
                isError: true,
                statusText: error,
                disabled: false
            });
        }
    }
}
